import { render, staticRenderFns } from "./changePassPhrase.vue?vue&type=template&id=501c9d18&"
import script from "./changePassPhrase.vue?vue&type=script&lang=js&"
export * from "./changePassPhrase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports